import * as yup from 'yup';

export const schema = yup
  .object({
    inputDescricao: yup.string().trim().required('Informe a descrição.'),

    tipo_categoria: yup
      .mixed()
      .transform((val) => (val && typeof val === 'object' ? val.value : val))
      .oneOf([0, 1, 2], 'Selecione a categoria.')
      .required('Selecione a categoria.'),
  })
  .required();
